import script from "./EditProyect.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProyect.vue?vue&type=script&setup=true&lang=js"

import "./EditProyect.vue?vue&type=style&index=0&id=67e1ff78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e1ff78"]])

export default __exports__